/**
 * 模板組件自動註冊系統
 * 自動載入所有 Tab2 組件，無需手動管理 import 語句
 */

// 使用 webpack 的 require.context 自動引入所有 Tab2 組件
const importAllComponents = () => {
  const componentMap = {};

  try {
    // 自動引入 TemplateTab2Content.jsx 中的所有組件
    const context = require.context(
      "../../pages/Template/TemplateDetailContent",
      false,
      /TemplateTab2Content\.jsx$/
    );

    context.keys().forEach((fileName) => {
      const componentModule = context(fileName);

      // 提取所有 E##Tab2 格式的組件
      Object.keys(componentModule).forEach((exportName) => {
        if (/^E\d+Tab2$/.test(exportName)) {
          const templateCode = exportName.replace("Tab2", ""); // E01Tab2 -> E01
          componentMap[templateCode] = componentModule[exportName];
        }
      });
    });

    // console.log("模板數量:", Object.keys(componentMap).length);
  } catch (error) {
    console.warn("無法自動載入組件，使用手動引入模式:", error);

    // 如果自動引入失敗，使用手動引入作為備用方案
    try {
      const allComponents = require("../../pages/Template/TemplateDetailContent/TemplateTab2Content");
      Object.keys(allComponents).forEach((exportName) => {
        if (/^E\d+Tab2$/.test(exportName)) {
          const templateCode = exportName.replace("Tab2", "");
          componentMap[templateCode] = allComponents[exportName];
        }
      });
      console.log("手動載入的組件數量:", Object.keys(componentMap).length);
    } catch (fallbackError) {
      console.error("手動引入也失敗了:", fallbackError);
    }
  }

  return componentMap;
};

// 組件註冊表
const TEMPLATE_COMPONENTS = importAllComponents();

/**
 * 根據模板編號獲取對應的 Tab2 組件
 * @param {string} templateCode - 模板編號 (如: 'E01', 'E02')
 * @returns {React.Component|null} - 對應的組件或 null
 */
export const getTemplateComponent = (templateCode) => {
  const component = TEMPLATE_COMPONENTS[templateCode];

  if (!component) {
    console.warn(`找不到模板 ${templateCode} 的 Tab2 組件`);
    return null;
  }

  return component;
};

/**
 * 獲取所有已註冊的組件
 * @returns {Object} - 所有組件的映射
 */
export const getAllTemplateComponents = () => {
  return { ...TEMPLATE_COMPONENTS };
};

/**
 * 檢查指定模板是否有對應的組件
 * @param {string} templateCode - 模板編號
 * @returns {boolean}
 */
export const hasTemplateComponent = (templateCode) => {
  return templateCode in TEMPLATE_COMPONENTS;
};

// 如果自動載入失效，提供手動註冊的備用方案
export const registerTemplateComponent = (templateCode, component) => {
  TEMPLATE_COMPONENTS[templateCode] = component;
  console.log(`手動註冊組件: ${templateCode}`);
};

export default TEMPLATE_COMPONENTS;
